import React from 'react'
import {
	ListItem,
	withStyles,
	Grid,
	ListItemSecondaryAction,
	Hidden,
} from '@material-ui/core'
import Menu from '../Menu'
import language from 'utils/vast-languagepack'
import {
	Done,
	SettingsInputAntenna,
	Loop,
	Pause,
	People,
	Email,
	Sms,
} from '@material-ui/icons'
import classNames from 'classnames'
import { startCase } from 'lodash'
// import { themeObj } from 'components/withRoot'

const IconMap = {
	W: (style) => <Loop style={style ? style : {}} />,
	P: (style) => <Pause style={style ? style : {}} />,
	L: (style) => <SettingsInputAntenna style={style ? style : {}} />,
	C: (style) => <Done style={style ? style : {}} />,
}

export default withStyles((theme) => ({
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: 'bold',
		display: 'table',
		tableLayout: 'fixed',
		width: '100%',
		whiteSpace: 'nowrap',
		marginBottom: 5,
	},
	description: {
		color: theme.palette.text.secondary,
		fontSize: theme.typography.pxToRem(15),
		display: 'table',
		tableLayout: 'fixed',
		width: '100%',
		whiteSpace: 'nowrap',
		marginBottom: 5,
	},
	createdHeading: {
		color: theme.palette.text.secondary,
		fontSize: theme.typography.pxToRem(12),
		fontWeight: 'bold',
		display: 'table',
		tableLayout: 'fixed',
		width: '100%',
		whiteSpace: 'nowrap',
		[theme.breakpoints.down('xs')]: {
			fontSize: theme.typography.pxToRem(11),
		},
	},
	text: {
		display: 'table-cell',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	createdDate: {
		color: theme.palette.secondary.main,
		display: 'inline-block',
	},
	secondaryAction: {
		paddingLeft: 80,
		minHeight: 120,
		position: 'relative',
		[theme.breakpoints.up('xs')]: {
			paddingRight: 33,
		},
		[theme.breakpoints.up('md')]: {
			paddingRight: 60,
		},
	},
	container: {
		listStyle: 'none',
		borderBottom: '1px solid #adadad',
		borderRight: '1px solid #adadad',
	},
	secondaryActionRoot: {
		[theme.breakpoints.up('xs')]: {
			top: 'calc(50% - 16px)',
		},
		[theme.breakpoints.up('md')]: {
			top: 'calc(50% - 24px)',
		},
	},
	info: {
		display: 'inline-block',
	},
	statSection: {
		textAlign: 'center',
		// display: 'inline-block',
		marginLeft: 10,
		// '&last-child': {
		//   marginLeft: 0,
		// },
	},
	statBlock: {
		width: 225,
		maxHeight: 135,
		borderRadius: 25,
		border: '1px solid #ccc',
		padding: 5,
		overflow: 'hidden',
		position: 'relative',
	},
	stage: {
		borderRadius: 20,
		height: 25,
		margin: '0 auto',
		color: '#fff',
	},
	stage0: {
		backgroundColor: theme.palette.secondary.main,
		width: '100%',
	},
	stage1: {
		backgroundColor: theme.palette.pink,
		width: '90%',
	},
	stage2: {
		backgroundColor: theme.palette.orange,
		width: '80%',
	},
	stage3: {
		backgroundColor: theme.palette.green,
		width: '70%',
	},
	stageMore: {
		backgroundColor: theme.palette.green,
		width: '70%',
	},
}))(({ classes, addOrEditPush, campaign, size, entityType }) => {
	const date = new Date(campaign.when_created)
	const statusObj = {
		W: 'Work in Progress',
		L: 'Live',
		P: 'Paused',
		C: 'Complete',
	}
	const colorObj = {
		W: '#930766',
		C: '#014c94',
		L: '#15b940',
		P: '#d89300',
	}

	let totalNumberOfStats = 0
	if (campaign.stats) {
		if (campaign.stats.email) {
			totalNumberOfStats += Object.keys(campaign.stats.email).length
		}
		if (campaign.stats.sms) {
			totalNumberOfStats += Object.keys(campaign.stats.sms).length
		}
	}

	return (
		<ListItem
			onClick={() => addOrEditPush(campaign.id)}
			key={`campaignsPageListItem${campaign.id}`}
			button
			classes={{
				container: classes.container,
				secondaryAction: classes.secondaryAction,
			}}
		>
			<div
				style={{
					position: 'absolute',
					left: 0,
					top: '50%',
					transform: 'translate(0, -50%)',
					textAlign: 'center',
					width: 80,
					color: colorObj[campaign.status],
					fontSize: 11,
					fontWeight: 'bold',
				}}
			>
				<div
					style={{
						width: '60px',
						height: '60px',
						borderRadius: '50%',
						backgroundColor: colorObj[campaign.status],
						margin: 'auto',
						color: '#fff',
					}}
				>
					{IconMap[campaign.status]({ marginTop: 17 })}
				</div>
				<div>{statusObj[campaign.status]}</div>
			</div>
			<Hidden smDown>
				<Grid container className={classes.info}>
					<Grid item md={12} lg={6}>
						<div className={classes.heading}>
							<span className={classes.text}>{campaign.name}</span>
						</div>
					</Grid>
					<Grid item md={12} lg={6}>
						<div className={classes.description}>
							<span className={classes.text}>{campaign.description}</span>
						</div>
					</Grid>
					<Grid item xs={12}>
						<div className={classes.createdHeading}>
							<span className={classes.text}>
								<em>
									<span>
										<span>{`${language.task.menuSort.created} `}</span>
										<span className={classes.createdDate}>
											{`${date.toLocaleDateString()}`}
										</span>
									</span>
								</em>
							</span>
						</div>
					</Grid>
				</Grid>
				{campaign.status !== 'W' && (
					<>
						{totalNumberOfStats ? (
							<div className={classes.statSection}>
								<div className={classes.statBlock}>
									<Grid container>
										{campaign?.stats?.sms
											? Object.keys(campaign.stats.sms).map((stat) => (
													<Grid
														item
														sm={12}
														md={totalNumberOfStats > 6 ? 6 : 12}
													>
														<Sms
															style={{
																marginRight: 5,
																color: '#ccc',
																verticalAlign: 'middle',
															}}
														/>
														{`${startCase(stat)}: ${campaign.stats.sms[stat]}`}
													</Grid>
											  ))
											: null}
										{campaign?.stats?.email
											? Object.keys(campaign.stats.email).map((stat) => (
													<Grid
														item
														sm={12}
														md={totalNumberOfStats > 6 ? 6 : 12}
													>
														<Email
															style={{
																marginRight: 5,
																color: '#ccc',
																verticalAlign: 'middle',
															}}
														/>
														{`${startCase(stat)}: ${
															campaign.stats.email[stat]
														}`}
													</Grid>
											  ))
											: null}
									</Grid>
								</div>
							</div>
						) : null}
						<div className={classes.statSection}>
							<div className={classes.statBlock}>
								{campaign?.stages.map((stage, idx) => (
									<div
										key={`list-campaign${campaign.id}-stage${stage.id}`}
										className={classNames(
											classes.stage,
											// classes.stageMore,
											classes[`stage${idx}`] || classes.stageMore,
										)}
									>
										<People
											style={{
												color: '#fff',
												verticalAlign: 'middle',
												marginRight: 5,
											}}
										/>
										{stage.current_contact_count}
									</div>
								))}
								{campaign?.stages.length > 5 && (
									<div
										style={{
											position: 'absolute',
											height: '100%',
											width: '100%',
											top: 0,
											left: 0,
											background: 'linear-gradient(rgba(255,255,255,0), #fff)',
										}}
									/>
								)}
							</div>
						</div>
					</>
				)}
			</Hidden>
			<Hidden mdUp>
				<Grid container>
					<Grid item xs={12} container>
						<Grid item md={12} lg={6}>
							<div className={classes.heading}>
								<span className={classes.text}>{campaign.name}</span>
							</div>
						</Grid>
						<Grid item md={12} lg={6}>
							<div className={classes.description}>
								<span className={classes.text}>{campaign.description}</span>
							</div>
						</Grid>
						<Grid item xs={12}>
							<div className={classes.createdHeading}>
								<span className={classes.text}>
									<em>
										<span>
											<span>{`${language.task.menuSort.created} `}</span>
											<span className={classes.createdDate}>
												{`${date.toLocaleDateString()}`}
											</span>
										</span>
									</em>
								</span>
							</div>
						</Grid>
					</Grid>
					{campaign.status !== 'W' && (
						<>
							{totalNumberOfStats ? (
								<Grid item xs={12} className={classes.statSection}>
									<div className={classes.statBlock}>
										<Grid container>
											{campaign?.stats?.sms
												? Object.keys(campaign.stats.sms).map((stat) => (
														<Grid
															item
															sm={12}
															md={totalNumberOfStats > 6 ? 6 : 12}
														>
															<Sms
																style={{
																	marginRight: 5,
																	color: '#ccc',
																	verticalAlign: 'middle',
																}}
															/>
															{`${startCase(stat)}: ${
																campaign.stats.sms[stat]
															}`}
														</Grid>
												  ))
												: null}
											{campaign?.stats?.email
												? Object.keys(campaign.stats.email).map((stat) => (
														<Grid
															item
															sm={12}
															md={totalNumberOfStats > 6 ? 6 : 12}
														>
															<Email
																style={{
																	marginRight: 5,
																	color: '#ccc',
																	verticalAlign: 'middle',
																}}
															/>
															{`${startCase(stat)}: ${
																campaign.stats.email[stat]
															}`}
														</Grid>
												  ))
												: null}
										</Grid>
									</div>
								</Grid>
							) : null}
							<Grid item xs={12} className={classes.statSection}>
								<div className={classes.statBlock}>
									{campaign?.stages.map((stage, idx) => (
										<div
											key={`list-campaign${campaign.id}-stage${stage.id}`}
											className={classNames(
												classes.stage,
												// classes.stageMore,
												classes[`stage${idx}`] || classes.stageMore,
											)}
										>
											<People
												style={{
													color: '#fff',
													verticalAlign: 'middle',
													marginRight: 5,
												}}
											/>
											{stage.current_contact_count}
										</div>
									))}
									{campaign?.stages.length > 5 && (
										<div
											style={{
												position: 'absolute',
												height: '100%',
												width: '100%',
												top: 0,
												left: 0,
												background:
													'linear-gradient(rgba(255,255,255,0), #fff)',
											}}
										/>
									)}
								</div>
							</Grid>
						</>
					)}
				</Grid>
			</Hidden>
			<ListItemSecondaryAction
			// classes={{ root: classes.secondaryActionRoot }}
			>
				<Menu
					vert
					entityName={campaign.name}
					entityType={entityType}
					entityID={campaign.id}
					addOrEditPush={addOrEditPush}
				/>
			</ListItemSecondaryAction>
		</ListItem>
	)
})
